import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LoggerService } from './app/core/services/logger.service';

// Crear instancia del logger para el main
const logger = new LoggerService();

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => logger.error('Error al inicializar la aplicación', err, 'Main'));